import { useState, useEffect } from 'react';

/**
 * Lazy-load the ReCAPTCHA component. This is required because:
 *
 * 1. Astro compilation fails if the component is imported directly
 * 2. Astro compilation fails with a different error if loaded via `React.lazy()`
 *
 * @example
 *
 * const ReCAPTCHAComponent = useReCAPTCHAComponent();
 *
 * return (
 * 	{ReCAPTCHAComponent && <ReCAPTCHAComponent {...whatever} />
 * )
 */

export const useReCAPTCHAComponent = () => {
	const [ReCAPTCHAComponent, setRecaptchaComponent] = useState<React.ComponentType<any>>();

	useEffect(() => {
		(async () => {
			const { default: Default, ...others } = await import('react-google-recaptcha');
			setRecaptchaComponent(Default);
		})();
	}, []);

	return ReCAPTCHAComponent;
};
